import LegalMdxWrapper from './src'

export default LegalMdxWrapper
